import Util from "@/helper/Utility.js";
import { DropdownListValue } from "@/helper/FormHelper.js"; //from helper;
import { FormHelper } from "@/helper/FormHelper.js"; //from helper

//helper
import Locale from "@/helper/locale/Locale.js";

export function RegisterModel() {
    this.username = '';
    this.firstName ='';
    this.lastName = '';
    this.email ='';
    this.gender = '';
    this.otp = '';
    this.refcode ='';
    this.contact_number ='';
    this.idcard ='';
    this.password_type = '';
    this.password = '';
    this.confirmpassword ='';
    this.pin ='';
    this.confirmpin ='';
    this.registerchannel ='buzzebees';
    this.register_channel ='buzzebees';
    this.linkuser = false;
    this.termandcondition = '1';
    this.checkTermandcondition = false;
    this.dataprivacy ='1';
    this.pdpaVersion = '';
    this.birthdate ='';
    this.point = 0;
    this.idToken = '';
    this.nationality = '';
    this.passport = '';
    this.refusercode = '';
    this.getParamsRegister = function (data) {
        let params = {
            username: data.contact_number,
            password_type: data.password_type,
            password: data.password_type === 'pin' ? data.pin :data.password,
            confirmpassword: data.password_type === 'pin' ? data.confirmpin :data.confirmpassword,
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            gender:  data.gender,
            registerchannel:  data.register_channel,
            contact_number:  data.contact_number,
            idcard:  data.nationality == 'thai' ? data.idcard : data.passport, //passport or idcard
            register_channel:  data.register_channel,
            // linkuser: false,
            id_token:  data.idToken,//line , facebook
            termandcondition:  data.pdpaVersion,
            dataprivacy:  data.pdpaVersion,
            birthdate:  data.birthdate,
            otp:  data.otp,
            refcode:  data.refcode,
            nationality: data.nationality,
            refusercode: data.refcodeGetFriend,
        }
        return Util.cleanObjectEmptyStr(params);
    },
    this.getDataProfileFromApi = function (data){
        this.username = '';
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
        this.gender = data.gender;
        this.otp = '';
        this.refcode = data.refercode;
        this.contact_number = data.contactNumber;
        this.idcard = data.nationality == 'thai' ? data.nationalIdCard : '';
        this.password_type = data.extensionJsonProperty.password_type;
        this.password = '';
        this.confirmpassword ='';
        this.pin ='';
        this.confirmpin ='';
        this.registerchannel ='buzzebees';
        this.register_channel ='buzzebees';
        this.linkuser = false;
        this.termandcondition = '1';
        this.checkTermandcondition = false;
        this.dataprivacy ='1';
        this.pdpaVersion = '';
        this.birthdate ='';
        this.point = 0;
        this.idToken = '';
        this.nationality = data.nationality == 'foreign' ? data.nationality : 'thai';
        this.passport = data.nationality == 'foreign' ? data.nationalIdCard : '';
        return Util.cleanObjectEmptyStr(this);
    },
    this.setNationalityList = function(){
        let nationality = new DropdownListValue();
        let lbl = Locale.getLbl();
        nationality.add(lbl.profile.thai, 'thai');
        nationality.add(lbl.profile.foreign, 'foreign');

        return nationality.getList();
    },
    this.setGenderList = function(){
        let gender = new DropdownListValue();
        let lbl = Locale.getLbl();
        gender.add(lbl.profile.female, 'female');
        gender.add(lbl.profile.male, 'male');

        return gender.getList();
    },
    this.setFormatPassword = function(){
        let format = new DropdownListValue();
        let lbl = Locale.getLbl();
        format.add(lbl.profile.password, 'password');
        format.add(lbl.profile.pincode, 'pin');

        return format.getList();
    }
}
export function ValidateForm(){
    this.checkFormatPassword = function(form){
        let password = form.password;
        if(password && form.password_type === 'password'){
            const passwordUppercase = password.match(/[A-Z]/g);
            const passwordLowercase = password.match(/[a-z]/g);
            const passwordNumber = password.match(/[0-9]/g);
            if(passwordUppercase && passwordLowercase && passwordNumber){
                return true;
            }
            return false;
        }
        return true;
    }
    this.validateForm = function(errorInfo){
        for(let i of errorInfo){
            if(!i.isValid){
                return false
            }
        }
        return true
    }
    this.validateMatchPassword = function(formData){
        if(formData.password_type === 'pin'){ //select pin
            return formData.confirmpin === formData.pin
        }else{ //select password
            return formData.confirmpassword === formData.password
        }
    }
    this.validatePasswordType = function(formData , errorPin , errorPassword){
        if (formData.password_type === 'pin') { //select pin
            return FormHelper.validate(errorPin);
        } else { //select password
            return FormHelper.validate(errorPassword);
        }
    }
}
